export default {
  'message': 'hello i18n !!',
  'Columns settings': 'Columns settings',
}
